import React from "react";

import CustomTooltip from "./CustomTooltip/CustomTooltip";

const InpersonClassSelectionModal = ({
  isOpen,
  onClose,
  continueEnrollingBt30,
  selectedSession,
}) => {
  if (!isOpen) return null;
  return (
    <div className="location-modal-overlay">
      <div className="in_person-content">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            style={{ fontSize: "22px", fontWeight: "700", marginLeft: "10px" }}
          >
            In-Person Class Selection
          </div>
          <CustomTooltip text="Close" placement="top">
            <button className="btn-close" onClick={onClose}></button>
          </CustomTooltip>
        </div>

        <div className="in_person_modal_data">
          <div className="in_person_modal_details">
            <div className="in_person_modal_subheading">
              You are selecting the following in-person class:
            </div>
            <div className="in_person_modal_selectedSession">
              {selectedSession.date}, {selectedSession.startTime} -{" "}
              {selectedSession.endTime}
            </div>
            <div className="in_person_modal_selectedSession">
              {selectedSession.cityLink.name}
            </div>
            <div className="in_person_modal_selectedSession">
              {selectedSession.cityLink.address}
            </div>
          </div>
        </div>

        <div className="in_person_modal_note">
          <div className="in_person_modal_note_icon">i</div>
          <div className="in_person_modal_note_data">
            <span style={{ fontWeight: "bold", textDecoration: "underline" }}>
              Note: If you are unable to make your in-person
              <br /> class,
            </span>{" "}
            you may reschedule it after you've enrolled.
          </div>
        </div>
        <div className="in_person_modal_actions">
          <button
            className="secondary_button"
            style={{ width: "120px" }}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="button"
            style={{ width: "120px" }}
            onClick={continueEnrollingBt30}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default InpersonClassSelectionModal;
